import { IForgotPasswordEmailBody, ISendNewPasswordBody } from '@app/interfaces/forgotPassword';
import { api } from '@app/api/http.api';

export const sendForgotPasswordEmailRequest = async (body: IForgotPasswordEmailBody) =>
  await api.post('/web/admin/reset-password/send-code', body);

export const sendNewPasswordRequest = async (body: ISendNewPasswordBody) =>
  await api.post('/web/admin/reset-password/new-password', body);
